const CONFIG = {
  backend_url: "https://album-world-backend.onrender.com",
};

export default CONFIG;